import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addOne, buildToastContent, removeOne, ToastContentLevel, reset } from '../toast/slice';

const useToast = () => {
  const dispatch = useDispatch();

  const add = useCallback(
    (level: ToastContentLevel, content: string) => {
      dispatch(addOne(buildToastContent(level, content)));
    },
    [dispatch]
  );

  const remove = useCallback(
    (id: string) => {
      dispatch(removeOne(id));
    },
    [dispatch]
  );
  const resetToast = useCallback(() => {
    dispatch(reset());
  }, [dispatch]);
  return { addToast: add, removeToast: remove, reset: resetToast };
};

export default useToast;
